import RecruitApiClient from '../../RecruitApiClient';
import { RequestIndex } from './types';

class Api {
  newQuestionTemplate = (params: any) =>
    RecruitApiClient.post('/api/v4/library_fields', { field: params });
  getQuestions: RequestIndex = (params) => RecruitApiClient.get('/api/v4/library_fields', params);
  deleteQuestion = (id: string) => RecruitApiClient.delete(`/api/v4/library_fields/${id}`);
  updateQuestion = (id: number, params: any) =>
    RecruitApiClient.put(`/api/v4/library_fields/${id}`, { field: params });
  importQuestions = (params: { job_id: number; library_field_ids: number[] }) =>
    RecruitApiClient.post('/api/v4/library_fields/import_fields', params);
  validateQuestionName = (params: {
    library_field_name: string;
  }): Promise<{ res: { error: string } }> =>
    RecruitApiClient.get(`/api/v4/library_fields/validate_question_name`, params);

  newTag = (params: any) => RecruitApiClient.post('/api/v4/tags', params);
  validateTagName = (params: { name: string }): Promise<{ res: { error: string } }> =>
    RecruitApiClient.get(`/api/v4/tags/validate_tag_name`, params);
  updateTag = (id: number, params: any) => RecruitApiClient.put(`/api/v4/tags/${id}`, params);
  getTags: RequestIndex = (params) => RecruitApiClient.get('/api/v4/tags', params);
  deleteTag = (id: string) => RecruitApiClient.delete(`/api/v4/tags/${id}`);
  bulkDeleteTags = (params: { tag_ids: number[] }) =>
    RecruitApiClient.post('/api/v4/tags/bulk_delete', params);
  mergeTags = (params: { primary_tag_id: number; tag_ids: number[]; new_tag_name: string }) =>
    RecruitApiClient.post('/api/v4/tags/merge', params);
  saveJobAsTemplate = (params: {
    id: number;
    job: { job_template_name: string };
  }): Promise<{
    res: { message: string };
  }> => RecruitApiClient.post(`/api/v4/job_templates/create_from_job`, params);
  getJobTemplates: RequestIndex = (params) => RecruitApiClient.get(`/api/v4/job_templates`, params);
  deleteJobTemplate = (id: string) => RecruitApiClient.delete(`/api/v4/job_templates/${id}`);
  createJobTemplate = (params: {
    job: { job_template_name: string };
  }): Promise<{
    res: { url: string };
  }> => RecruitApiClient.post(`/api/v4/job_templates`, params);
  cloneJobTemplate = (params: {
    id: number;
    job: { job_template_name: string };
  }): Promise<{
    res: { message: string };
  }> => RecruitApiClient.post(`/api/v4/job_templates/clone`, params);
  validateJobTemplateName = (params: {
    job_template_name: string;
  }): Promise<{
    res: { error: string };
  }> => RecruitApiClient.get(`/api/v4/job_templates/validate_template_name`, params);
}

export default new Api();
